// LoginDesktop.jsx
import { useContext, useEffect } from "react";
import googleIcon from "../../src/images/google-icon.png";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";

import USFlag from "../../src/images/flags/uk-flag-icon.png";
import FranceFlag from "../../src/images/flags/french-flag-icon.png";
import TalkmateLogo from "../../src/images/talk_mate_square.png";
import { useAuth } from "../context/AuthContext";
import { showCustomToast } from "../misc/CustomToast";
import { LanguageContext } from "../context/LanguageContext";
import { useNavigate } from "react-router-dom";
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import BGLogin from "../images/bgapp.png";
import { useTheme } from "@mui/material/styles";

export default function LoginDesktop() {
  const theme = useTheme();
  const { translate, language, setLanguage } = useContext(LanguageContext);
  const handleLanguageChange = (event) => {
    setLanguage(event.target.value);
  };
  const navigate = useNavigate();
  const { signInWithGoogle, currentUser } = useAuth();

  async function handleSignInWithGoogle() {
    try {
      const result = await signInWithGoogle();
      const user = result.user;

      // 1) Vérifier si profil existe déjà
      const profileRef = doc(db, "profilsUsers", user.uid);
      const snap = await getDoc(profileRef);

      if (!snap.exists()) {
        // 2) Créer un tenant automatiquement
        const tenantRef = doc(db, "tenants", user.uid); // tenantId = uid (simple pour start)
        await setDoc(tenantRef, {
          name: user.displayName || "My Company",
          ownerId: user.uid,
          createdAt: serverTimestamp(),
          plan: "free",
          agentsCount: 0,
        });

        // 3) Créer le profil utilisateur lié à ce tenant
        await setDoc(profileRef, {
          name: user.displayName,
          email: user.email,
          photoUrl: user.photoURL,
          tenantId: tenantRef.id,
          role: "owner",
          createdAt: serverTimestamp(),
        });
      }

      showCustomToast(translate("SuccessfullyLoggedInWithGoogle"), "success");
    } catch (error) {
      showCustomToast(
        translate("Failed to log in with your Google account"),
        "error"
      );
    }
  }

  useEffect(() => {
    if (!currentUser) return;
    (async () => {
      const snap = await getDoc(doc(db, "profilsUsers", currentUser.uid));
      const data = snap.data() || {};
      if (data.tenantId) {
        navigate("/app"); // dashboard du tenant
      } else {
        navigate("/app/profile", { replace: true });
      }
    })();
  }, [currentUser, navigate]);

  return (
    <div
      className="sign-main-container"
      style={{
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.default,
      }}
    >
      <div className="sign-left-container">
        <img
          src={TalkmateLogo}
          alt="Rehapp Logo"
          style={{ height: "100px", width: "auto" }}
        />

        <div
          style={{
            height: "40%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignContent: "center",
            alignItems: "center",
            paddingTop: "10px",
          }}
        >
          <Box className="signup-title" sx={{ color: "text.primary" }}>
            {translate("WelcomeToTalkmate")}
          </Box>

          <Button
            sx={{
              borderRadius: "30px",
              paddingTop: "10px",
              paddingBottom: "10px",
              color: theme.palette.text.primary,
              borderColor: theme.palette.divider,
              width: "100%",
              fontSize: "14px",
            }}
            variant="outlined"
            onClick={handleSignInWithGoogle}
          >
            <img alt="Google icon" src={googleIcon} width="30px" />
            <div style={{ paddingLeft: 20 }}>
              {translate("LogInWithGoogle")}
            </div>
          </Button>

          <FormControl
            variant="outlined"
            size="small"
            sx={{ minWidth: 180, marginTop: 3 }}
          >
            <InputLabel id="language-select-label">Language</InputLabel>
            <Select
              value={language}
              onChange={handleLanguageChange}
              renderValue={(selected) => (
                <Box display="flex" alignItems="center">
                  {selected === "en" && (
                    <img
                      src={USFlag}
                      alt="US Flag"
                      style={{ width: 20, marginRight: 10 }}
                    />
                  )}
                  {selected === "fr" && (
                    <img
                      src={FranceFlag}
                      alt="France Flag"
                      style={{ width: 20, marginRight: 10 }}
                    />
                  )}
                  {selected === "en"
                    ? "English"
                    : selected === "fr"
                    ? "Français"
                    : "ภาษาไทย"}
                </Box>
              )}
            >
              <MenuItem value="en">English</MenuItem>
              <MenuItem value="fr">Français</MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>

      <div
        className="sign-right-container-2"
        style={{
          flex: 1,
          borderLeft: `1.5px solid ${theme.palette.divider}`,
          backgroundImage: `url(${BGLogin})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />

      <ToastContainer />
    </div>
  );
}
